import React from 'react';
import withAnimation from '../../../hooks/withAnimation';
import { useNavigate } from 'react-router-dom';

// const relatedConditions = [
//     {
//       title: "Chronic Back Pain",
//       captionDescription: "Persistent pain in the lower back that lasts for more than 12 weeks.",
//       imageUrl: require('../../../assets/images/arthiritis.jpg'),
//       link: "/conditions/chronic-back-pain"
//     },
//     {
//       title: "Sciatica",
//       captionDescription: "Pain that radiates along the sciatic nerve from the lower back down to the leg.",
//       imageUrl:  require('../../../assets/images/balancetraining.jpg'),
//       link: "/conditions/sciatica"
//     },
//     {
//       title: "Herniated Disc",
//       captionDescription: "A condition where the soft center of a spinal disc pushes through a crack in the tougher exterior casing.",
//       imageUrl:  require('../../../assets/images/chronic.jpg'),
//       link: "/conditions/herniated-disc"
//     },
    
//   ];
  
  

const RelatedConditions = ({ conditions }) => {
  const navigate = useNavigate()
  return (
    <section className="relative bg-gray-50 py-16">
      <div className="container mx-auto px-6 lg:px-16">
        <h2 className="text-4xl font-extrabold text-primary text-center mb-12">Related Conditions</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {conditions.map((condition, index) => (
            <div 
              key={index} 
              className="relative bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300 ease-in-out"
            >
              <img src={condition.relatedImage} alt={condition.title} className="w-full h-48 object-cover"/>
              <div className="p-6">
                <h3 className="text-2xl font-semibold text-primary mb-2">{condition.title}</h3>
                <p className="text-gray-700 text-base">{condition.captionDescription}</p>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-primary to-transparent opacity-0 hover:opacity-75 transition-opacity duration-300 ease-in-out">
                <div className="flex items-center justify-center h-full">
                  <a onClick={()=>navigate(condition.link)} className="text-white text-lg font-semibold">Learn More</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default withAnimation(RelatedConditions);
